module.exports = __webpack_public_path__ + "img/fide.67716e31.png";